export default { version: '7.17.18' };
